import { render, staticRenderFns } from "./ColumnMenu.vue?vue&type=template&id=88cf9e9a&scoped=true&"
import script from "./ColumnMenu.vue?vue&type=script&lang=js&"
export * from "./ColumnMenu.vue?vue&type=script&lang=js&"
import style0 from "./ColumnMenu.vue?vue&type=style&index=0&id=88cf9e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cf9e9a",
  null
  
)

export default component.exports